(function () {
  'use strict';

  angular
    .module('dtmService.module')
    .directive('dataLayerErrorFormField', ['dataLayerService', '$timeout', 'dtmServiceConstants',  function (dataLayerService, $timeout, dtmServiceConstants) {
      return {
        restrict: 'AE',
        scope: {errorPayload: '=', errorField: '@' , isModalWindow: '=', fireRule: '=', errorType: '=', pageView: '='},
        link: function ($scope, $element, attrs) {
          if(!($scope.fireRule === false)){
            $scope.$applyAsync(function (){
              var addSelectedBasicPayload = angular.isDefined($scope.pageView) ? dtmServiceConstants.dataLayerTrack.basicPayloadSections : dtmServiceConstants.dataLayerTrack.basicPayloadInfo;
              $scope.isModalPopup = angular.isDefined($scope.isModalWindow)? $scope.isModalWindow : false;
              if(angular.isDefined($scope.errorType)){
                dataLayerService.trackError($scope.errorPayload, $scope.errorType, '',
                  $element.text().trim(), $scope.isModalPopup, addSelectedBasicPayload, dtmServiceConstants.dataLayerTrack.errorType.selfServeTransaction,
                  false, $scope.errorField);
              }else{
                dataLayerService.trackError($scope.errorPayload, dtmServiceConstants.dataLayerTrack.errorType.form, '',
                  $element.text().trim(), $scope.isModalPopup, addSelectedBasicPayload, dtmServiceConstants.dataLayerTrack.errorType.selfServeTransaction,
                  false, $scope.errorField);
              }
            });
          }
        }
      };

    }]);
})();

